<template>
  <b-col md="12" sm="8" style="padding: 5px 5px 5px 5px">
    <b-card no-body class="mx-4">
      <b-card-header header-bg-variant="primary" header-text-variant="white">
        <h4 class="titulo" style="font-size: 24px !important"><span class="bold">Formulário {{questionario.titulo}}</span></h4>
      </b-card-header>
      <b-card-body class="p-4">
        <h5 class="text-center bold">{{mensagem}}</h5>
      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>

export default {
  name: 'Mensagem',
  computed: {
    questionario () {
      return this.$store.state.questionario.questionarioResponder
    },
    mensagem () {
      return this.$store.state.mensagem.mensagem
    },
    tipo () {
      return this.$store.state.mensagem.tipo
    }
  }
}
</script>

<style scoped>
.sistema-nome {
    text-align: right;
}

.secao-head {
  background-color: lightgrey;
  font-weight: bold;
  font-size: 18px;
}

.titulo {
    text-align: center;
}
</style>

<style>
.editor {
    width: 100%;
    height: 80%;
}

.bold {
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/externa/Mensagem.vue